import { TypedController } from "@vytant/stimulus-decorators";
import { Controller } from "stimulus";

@TypedController
export default class extends Controller<HTMLFormElement> {
  handleClick(event: MouseEvent) {
    const isEmbedded = window.self !== window.top // iframe

    if (isEmbedded) {
      event.preventDefault();

      const target = event.target as HTMLElement
      const url = target.dataset.url

      if (url) {
        window.parent.postMessage({
          type: 'SOCIAL_LOGIN_STARTED',
          url: url
        }, '*')
      }
    }
  }
}
